"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quota/quota-type.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquota%2Fquota-type.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.quotaTypeToJSON = exports.quotaTypeFromJSON = exports.QuotaType = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.quota.proto';
/**
 * The type of the quota (i.e. the type of key used for the quota). Not
 * enforced, just used to avoid showing irrelevant quotas in the admin UI.
 */
var QuotaType;
(function (QuotaType) {
    QuotaType["INVALID_TYPE"] = "INVALID_TYPE";
    QuotaType["USER"] = "USER";
    QuotaType["FAMILY"] = "FAMILY";
    QuotaType["DEVICE"] = "DEVICE";
    QuotaType["EXTERNAL_CARD"] = "EXTERNAL_CARD";
    QuotaType["EXTERNAL_BANK"] = "EXTERNAL_BANK";
    QuotaType["AGENT"] = "AGENT";
    QuotaType["ENCRYPTED_SSN"] = "ENCRYPTED_SSN";
    QuotaType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(QuotaType || (exports.QuotaType = QuotaType = {}));
function quotaTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TYPE':
            return QuotaType.INVALID_TYPE;
        case 1:
        case 'USER':
            return QuotaType.USER;
        case 2:
        case 'FAMILY':
            return QuotaType.FAMILY;
        case 3:
        case 'DEVICE':
            return QuotaType.DEVICE;
        case 4:
        case 'EXTERNAL_CARD':
            return QuotaType.EXTERNAL_CARD;
        case 5:
        case 'EXTERNAL_BANK':
            return QuotaType.EXTERNAL_BANK;
        case 6:
        case 'AGENT':
            return QuotaType.AGENT;
        case 7:
        case 'ENCRYPTED_SSN':
            return QuotaType.ENCRYPTED_SSN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return QuotaType.UNRECOGNIZED;
    }
}
exports.quotaTypeFromJSON = quotaTypeFromJSON;
function quotaTypeToJSON(object) {
    switch (object) {
        case QuotaType.INVALID_TYPE:
            return 'INVALID_TYPE';
        case QuotaType.USER:
            return 'USER';
        case QuotaType.FAMILY:
            return 'FAMILY';
        case QuotaType.DEVICE:
            return 'DEVICE';
        case QuotaType.EXTERNAL_CARD:
            return 'EXTERNAL_CARD';
        case QuotaType.EXTERNAL_BANK:
            return 'EXTERNAL_BANK';
        case QuotaType.AGENT:
            return 'AGENT';
        case QuotaType.ENCRYPTED_SSN:
            return 'ENCRYPTED_SSN';
        case QuotaType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.quotaTypeToJSON = quotaTypeToJSON;
//# sourceMappingURL=quota-type.js.map